import PortfolioManagersTable from 'components/Widgets/Tables/PortfolioManagersTable';
import DocumentsWidget from 'components/Widgets/DocumentsWidget';
import NotesWidget from 'components/NotesWidget';
import TableA from 'components/Widgets/Tables/TableA';
import TableB from 'components/Widgets/Tables/TableB';
import RollingPerformanceTable from 'components/Widgets/Tables/RollingPerformanceTable';
import HoldingDetailsTable from 'components/Widgets/Tables/HoldingDetailsTable';
import PortfolioMainExposureChart from 'components/Widgets/PortfolioMainExposureChart';
import ComparativeStatsTable from 'components/Widgets/Tables/ComparativeStatsTable';
import ScatterChart from 'components/Widgets/ScatterChart';
import FusionChart from 'components/Widgets/FusionChart';
import PerformanceWidget from 'components/Widgets/PerformanceWidget';
import HoldingInvestorPerformanceWidget from 'components/Widgets/HoldingInvestorPerformanceWidget';
import ClusterDiagram from 'components/Widgets/ClusterDiagram/ClusterDiagram';
import {
  defaultChartDataSource,
  scatterChartDataSource,
  bubbleChartDataSource,
  pieChartDataSource,
  customStackedColumnChartB,
  strategyExposureChart
} from './dataSourceTypes';
import widgetEndpoints from './widgetEndpoints';

const selectComponent = overlayId => {
  if (overlayId > 1000000 && overlayId < 2000000) {
    return {
      component: TableA,
      endpoint: widgetEndpoints[192],
      dataSourceHandler: null
    };
  }

  if (overlayId >= 2000003) {
    return {
      component: FusionChart,
      endpoint: widgetEndpoints[194],
      dataSourceHandler: defaultChartDataSource
    };
  }

  if (overlayId >= 2000000 && overlayId <= 2000002) {
    return {
      component: FusionChart,
      endpoint: widgetEndpoints[193],
      dataSourceHandler: defaultChartDataSource
    };
  }

  switch (overlayId) {
    case 0:
      return {
        component: ClusterDiagram,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null
      };
    case 1:
      return {
        component: PortfolioManagersTable,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null,
        query: {
          paramDefaultValue: 'Holding',
          paramName: 'groupBy'
        }
      };

    case 3:
    case 7:
    case 23:
    case 24:
    case 45:
    case 46:
    case 47:
    case 48:
    case 125:
    case 126:
    case 127:
    case 128:
    case 153:
    case 160:
    case 188:
    case 192:
      return {
        component: TableA,
        endpoint: widgetEndpoints[192],
        dataSourceHandler: null
      };

    case 191:
      return {
        component: HoldingInvestorPerformanceWidget,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null
      };
    case 119:
    case 120:
    case 121:
    case 122:
    case 123:
    case 124:
      return {
        component: FusionChart,
        dataSourceHandler: customStackedColumnChartB,
        endpoint: widgetEndpoints[overlayId]
      };
    case 25:
    case 186:
      return {
        component: FusionChart,
        dataSourceHandler: bubbleChartDataSource,
        endpoint: widgetEndpoints[overlayId]
      };

    case 36:
    case 159:
    case 189:
    case 190:
      return {
        component: ComparativeStatsTable,
        endpoint: widgetEndpoints[overlayId],
        query: {
          paramDefaultValue: 'Send',
          paramName: 'request'
        }
      };

    case 37:
    case 141:
    case 158:
    case 187:
      return {
        component: RollingPerformanceTable,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null
      };

    case 49:
      return {
        component: PortfolioMainExposureChart,
        dataSourceHandler: defaultChartDataSource,
        endpoint: widgetEndpoints[overlayId],
        query: {
          paramDefaultValue: 'LongShort',
          paramName: 'returnData'
        }
      };

    case 67:
      return {
        component: NotesWidget,
        endpoint: widgetEndpoints[overlayId]
      };
    case 118:
      return {
        component: ScatterChart,
        dataSourceHandler: scatterChartDataSource,
        endpoint: widgetEndpoints[overlayId]
      };
    case 151:
      return {
        component: FusionChart,
        dataSourceHandler: defaultChartDataSource,
        endpoint: widgetEndpoints[overlayId],
        query: {
          paramDefaultValue: 'Gross',
          paramName: 'returnData'
        }
      };
    case 152:
      return {
        component: FusionChart,
        dataSourceHandler: defaultChartDataSource,
        endpoint: widgetEndpoints[overlayId],
        query: {
          paramDefaultValue: 'Net',
          paramName: 'returnData'
        }
      };
    case 179:
      return {
        component: HoldingDetailsTable,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null
      };
    case 180:
      return {
        component: PerformanceWidget,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null
      };
    case 181:
      return {
        component: DocumentsWidget,
        endpoint: widgetEndpoints[overlayId]
      };
    case 139:
      return {
        component: FusionChart,
        dataSourceHandler: pieChartDataSource,
        endpoint: widgetEndpoints[overlayId]
      };
    case 39:
      return {
        component: FusionChart,
        dataSourceHandler: strategyExposureChart,
        endpoint: widgetEndpoints[overlayId]
      };
    case 22:
    case 43:
      return {
        component: TableB,
        endpoint: widgetEndpoints[overlayId],
        dataSourceHandler: null
      };

    default:
      return {
        component: FusionChart,
        dataSourceHandler: defaultChartDataSource,
        endpoint: widgetEndpoints[overlayId]
      };
  }
};

export default selectComponent;
